import Api from '../../path';
import { fetchData } from '@umu/umu-fetch'; 
 
export interface ICourseProgress {
	time: number;
	status: number;
	participate_num: string;
	complete_rate: number;
	leading_percent: number;
}

export const getCourseProgress = (courseId: string, uid?: string): Promise<IResponse<ICourseProgress>> => {
	const param:{[key: string]: string} = {group_id: courseId};
	if (uid) {
		param.uid = uid;
	}
	return fetchData(Api.COURSE_LEGRESS, param).then((res: IResponse<ICourseProgress>) => {
		return res;
	});
};
